import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { textureChangeFrame } from '../../../core/helpers/textureChangeFrame';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { isMobile } from '../../../core/helpers/isMobile';

function IconBackGround({
  x = 0,
  y = 0,
  children,
  handleSelect,
  name = '',
  scale = isMobile() ? 0.77 : 0.53,
  isSelect = false,
  isDisabled = false,
  hasSelectedState = true,
  additionalBackGroundImages = null,
  pointerUp = () => {},
  pointerDown = () => {},
  pointerOut = () => {},
  pointerMove = () => {},
}) {
  const { iconBgDefault, iconBgPressed, iconBgHovered, iconBgSelected, iconBgDisabled } =
    useMemo(() => {
      return additionalBackGroundImages || getGameImages();
    }, [additionalBackGroundImages]);

  const textureRef = useRef();
  const handlePointerDown = useCallback(
    (e) => {
      textureChangeFrame(e.currentTarget.children[0], iconBgPressed);
      pointerDown(e);
    },
    [iconBgPressed, pointerDown]
  );

  const handlePointerUp = useCallback(
    (e) => {
      handleSelect(e);
      textureChangeFrame(
        e.currentTarget.children[0],
        hasSelectedState && isSelect ? iconBgSelected : iconBgDefault
      );
      pointerUp(e);
    },
    [handleSelect, hasSelectedState, isSelect, iconBgDefault, iconBgSelected, pointerUp]
  );

  const handlePointerOut = useCallback(
    (e) => {
      textureChangeFrame(
        e.currentTarget.children[0],
        isSelect && hasSelectedState ? iconBgSelected : iconBgDefault
      );
      pointerOut(e);
    },
    [hasSelectedState, isSelect, iconBgSelected, iconBgDefault, pointerOut]
  );

  const handlePointerMove = useCallback(
    (e) => {
      textureChangeFrame(
        e.currentTarget.children[0],
        isSelect && hasSelectedState ? iconBgSelected : iconBgHovered
      );
      pointerMove(e);
    },
    [hasSelectedState, isSelect, iconBgSelected, iconBgHovered, pointerMove]
  );

  useEffect(() => {
    textureChangeFrame(textureRef.current, isSelect ? iconBgSelected : iconBgDefault);
  }, [isSelect, iconBgDefault, iconBgSelected]);

  return (
    <Container
      y={y}
      x={x}
      name={name}
      interactive={!isDisabled}
      cursor={isDisabled ? 'default' : 'pointer'}
      pointerup={handlePointerUp}
      pointerout={handlePointerOut}
      pointerdown={handlePointerDown}
      pointermove={isMobile() ? () => {} : handlePointerMove}
    >
      <Sprite
        texture={isDisabled ? iconBgDisabled : iconBgDefault}
        anchor={0.5}
        ref={textureRef}
        scale={scale}
      />
      {children}
    </Container>
  );
}

export default IconBackGround;
